<template>
    <div class="topbar-item">
        
        <div
            class="btn btn-icon w-auto btn-clean d-flex align-items-center btn-lg px-2"
            id="kt_quick_user_toggle"
        >
            <span
                class="text-muted font-weight-bold font-size-base d-none d-md-inline mr-1"
            >
                Merhaba, 
            </span>
            <span
                class="text-dark-50 font-weight-bolder font-size-base d-none d-md-inline mr-3"
            >
                {{ currentUserPersonalInfo.user?.name }}
            </span>
            <span class="symbol symbol-35 symbol-light-success">
                <img
                    v-if="true"
                    alt="Pic"
                    :src="currentUserPersonalInfo.user?.photo"
                />
                <span
                    v-if="false"
                    class="symbol-label font-size-h5 font-weight-bold"
                >
                    {{ currentUserPersonalInfo.user?.name.substring(0, 1) }}
                </span>
            </span>
        </div>
        <div
            id="kt_quick_user"
            ref="kt_quick_user"
            class="offcanvas offcanvas-right p-10"
        >
            <!--begin::Header-->
            <div
                class="offcanvas-header d-flex align-items-center justify-content-between pb-5"
            >
                <h3 class="font-weight-bold m-0">
                    Kullanıcı Profili
                    <!--
                    <small class="text-muted font-size-sm ml-2"
                        >12 mesaj</small
                    >
                    -->
                </h3>
                <a
                    href="#"
                    class="btn btn-xs btn-icon btn-light btn-hover-primary"
                    id="kt_quick_user_close"
                >
                    <i class="ki ki-close icon-xs text-muted"></i>
                </a>
            </div>
            <!--end::Header-->

            <!--begin::Content-->
            <perfect-scrollbar
                class="offcanvas-content pr-5 mr-n5 scroll"
                style="max-height: 90vh; position: relative;"
            >
                <!--begin::Header-->
                <div class="d-flex align-items-center mt-5">
                    <div class="symbol symbol-100 mr-5">
                        <img
                            v-if="currentUserPersonalInfo.user?.photo" 
                            class="symbol-label"
                            :src="currentUserPersonalInfo.user?.photo"
                            alt=""
                        />
                        <i class="symbol-badge bg-success"></i>
                    </div>
                    <div class="d-flex flex-column">
                        
                        <h4>{{ currentUserPersonalInfo.user?.name }}</h4>
                        <!--<div class="text-muted mt-1">Application Developer</div>-->
                        <div class="navi mt-2">
                            <a href="#" class="navi-item">
                                <span class="navi-link p-0 pb-2">
                                    <span class="navi-icon mr-1">
                                        <span
                                            class="svg-icon svg-icon-lg svg-icon-primary"
                                        >
                                            <!--begin::Svg Icon-->
                                            <inline-svg
                                                src="media/svg/icons/Communication/Mail-notification.svg"
                                            />
                                            <!--end::Svg Icon-->
                                        </span>
                                    </span>
                                    <span
                                        class="navi-text text-muted text-hover-primary"
                                    >
                                        {{ currentUserPersonalInfo.user?.email }}
                                    </span>
                                </span>
                            </a>
                        </div>
                        <button
                            class="btn btn-light-primary btn-bold"
                            @click="onLogout"
                        >
                            Çıkış
                        </button>
                    </div>
                </div>
                <!--end::Header-->
                <div class="separator separator-dashed mt-8 mb-5"></div>
                <!--begin Nav-->
                
                <div class="navi navi-spacer-x-0 p-0">
                    <router-link
                        to="/builder"
                        @click.native="closeOffcanvas"
                        href="#"
                        class="navi-item"
                    >
                        <div class="navi-link">
                            <div class="symbol symbol-40 bg-light mr-3">
                                <div class="symbol-label">
                                    <span
                                        class="svg-icon svg-icon-md svg-icon-success"
                                    >
                                        <inline-svg
                                            src="media/svg/icons/General/Notification2.svg"
                                        />
                                    </span>
                                </div>
                            </div>
                            <div class="navi-text">
                                <router-link to="/user/my_profile">
                                    <div class="font-weight-bold">
                                        Profilim
                                    </div>
                                </router-link>
                                <div class="text-muted">
                                    Kullanıcı hesabı detayları ve daha fazlası
                                    <router-link to="/user/my_profile">
                                        <span
                                            class="label label-light-danger label-inline font-weight-bold"
                                        >
                                            Güncelle
                                        </span>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </router-link>
           
                </div>
                <!--end::Notifications-->
            </perfect-scrollbar>
            <!--end::Content-->
            
        </div>
    </div>
</template>

<style lang="scss" scoped>
#kt_quick_user {
    overflow: hidden;
}
</style>

<script>
import { mapGetters } from "vuex";
import { LOGOUT } from "@/core/services/store/auth.module";
import KTLayoutQuickUser from "@/assets/js/layout/extended/quick-user.js";
import KTOffcanvas from "@/assets/js/components/offcanvas.js";

export default {
    name: "KTQuickUser",
    
    data() {
        return {
            list: [
                {
                    title: "Another purpose persuade",
                    desc: "Due in 2 Days",
                    alt: "+28%",
                    svg: "media/svg/icons/Home/Library.svg",
                    type: "warning"
                },
                {
                    title: "Would be to people",
                    desc: "Due in 2 Days",
                    alt: "+50%",
                    svg: "media/svg/icons/Communication/Write.svg",
                    type: "success"
                },
                {
                    title: "Purpose would be to persuade",
                    desc: "Due in 2 Days",
                    alt: "-27%",
                    svg: "media/svg/icons/Communication/Group-chat.svg",
                    type: "danger"
                },
                {
                    title: "The best product",
                    desc: "Due in 2 Days",
                    alt: "+8%",
                    svg: "media/svg/icons/General/Attachment2.svg",
                    type: "info"
                }
            ],
            firstCharOfName: "",
            
        };
    },
    mounted() {
        // Init Quick User Panel
        KTLayoutQuickUser.init(this.$refs["kt_quick_user"]);
        this.$store.dispatch('getUserPersonalInfo');
        
        
    },
    methods: {
        //...mapActions(["getUserPersonalInfo"]),
        onLogout() {
            this.$store
                .dispatch(LOGOUT)
                .then(() => this.$router.push({ name: "login" }));
        },
        closeOffcanvas() {
            new KTOffcanvas(KTLayoutQuickUser.getElement()).hide();
        },
        
    },
    created(){
        
    },
    computed: {
        ...mapGetters(["currentUserPersonalInfo"]),
    
    },
    
};
</script>
